<div class="modal-header">
  <h4 class="modal-title">Cadastro de produto permitido</h4>
  <button _ngcontent-jop-c162="" type="button" aria-label="Close" class="btn-close float-end" (click)="fechar()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="formulario">
    <div class="mt-3 row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="codigoProduto"><b>Código do produto  </b></label>
        <input (keyup)="buscar()"
               class="form-control"
               name="codigoProduto"
               ngDefaultControl
               formControlName="codigoProduto">

        <div *ngIf="produtosPermitidos?.length && formulario?.value?.codigoProduto"
             class="border mt-2 p-2"
             style="color: gray;">
          <div *ngFor="let item of produtosPermitidos"
               class="p-1">
            {{ item.id }} - {{ item.sigla || 'NOME INDEFINIDO' }}
          </div>
        </div>
      </div>
    </div>
  </form>
  <div *ngIf="mensagemAviso" class="alert alert-warning">
    {{mensagemAviso}}
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-danger" (click)="fechar()">Fechar</button>
  <button class="btn btn-success" [disabled]="formulario.invalid" (click)="salvar()">Salvar</button>
</div>
